<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>

            <a-descriptions-item label="需求名称">{{ form.needName }}</a-descriptions-item>
            <a-descriptions-item label="需求内容">
                <span v-html="form.needBody"></span>
            </a-descriptions-item>
            <a-descriptions-item label="需求类型">
                <dict-render :dict-obj="dictObjs['demand_type']" :text="form.needType"
                             v-if="form.needType"></dict-render>
            </a-descriptions-item>

            <a-descriptions-item label="发布者名称">{{form.needUserName}}</a-descriptions-item>

            <a-descriptions-item label="审核时间">{{form.auditTime}}</a-descriptions-item>

            <a-descriptions-item label="对接用户名称">{{form.abutmentUserName}}</a-descriptions-item>

            <a-descriptions-item label="对接用户联系方式">{{form.abutmentPhone}}</a-descriptions-item>
            <a-descriptions-item label="开始对接时间">{{form.abutmentStartTime}}</a-descriptions-item>
            <a-descriptions-item label="对接完成时间">{{form.abutmentEndTime}}</a-descriptions-item>
            <a-descriptions-item label="审核状态">
                <dict-render :dict-obj="dictObjs['aduit_status']" :text="form.auditStatus"
                             v-if="form.auditStatus"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="对接状态">
                <dict-render :dict-obj="dictObjs['serviceStatus']" :text="form.serviceStatus"
                             v-if="form.serviceStatus"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="是否公开">
                <dict-render :dict-obj="dictObjs['isPublic']" :text="form.isOpen" v-if="form.isOpen"></dict-render>
            </a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
    import {formMixin, dictMixin} from "@/mixins";
    import DictRender from "@/components/other/DictRender";

    export default {
        name: "Detail",
        mixins: [formMixin, dictMixin],
        components: {DictRender},
        data() {
            return {
                dictNames: "demand_type,aduit_status,serviceStatus,isPublic",
                form: {
                    id: null,
                    needName: null,
                    needBody: null,
                    needType: null,
                    needUserName: null,
                    auditTime: null,
                    abutmentPhone: null,
                    abutmentUserName: null,
                    abutmentStartTime: null,
                    abutmentEndTime: null,
                    serviceStatus: null,
                    isOpen: null,
                },
            }
        },
        methods: {
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            },
        }
    }
</script>

<style scoped lang="less">

</style>
